module.exports = __webpack_public_path__ + "assets_app/img/homeknop.f7311252.png";